import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { environment } from '../../../../environments/environment'
import { LocationSnapshot } from '../types/LocationSnapshot';
import { LocationSnapshotFilters } from '../types/LocationSnapshotFilters';
import { BatchReportsService } from '../../batch-reports-grid/batch-reports-service';


@Injectable()
export class LocationSnapshotService {

    constructor(private http: HttpClient, private notificationService: NotificationService, private batchReportsService: BatchReportsService) {

    }

    getUserCountries(apexId:string, isIGAdmin:boolean, isPowerUser:boolean, forAmerica:boolean, forEurope:boolean, forAsia:boolean, onlyDnB: boolean, onlySAP: boolean):Observable<any> {
        return this.http.get<any>(environment.apiBaseUrl + `locationsnapshot/usercountries?apexId=${apexId}&isIGAdmin=${isIGAdmin}&isPowerUser=${isPowerUser}&forAmerica=${forAmerica}&forEurope=${forEurope}&forAsia=${forAsia}&onlyDnB=${onlyDnB}&onlySAP=${onlySAP}`).pipe(
            catchError(err => this.handleError(err)),
        );
      }

    getAPPlantsByCountry(countryIDs:string, isPowerUser:boolean):Observable<any> {
       return this.http.get<any>(environment.apiBaseUrl + `locationsnapshot/applants?countryIDs=${countryIDs}&isPowerUser=${isPowerUser}`).pipe(
           catchError(err => this.handleError(err)),
       );
    }

    getAllGlobalIndustrySegments():Observable<any> {
        return this.http.get<any>(environment.apiBaseUrl + `locationsnapshot/globalindustrysegments`).pipe(
            catchError(err => this.handleError(err)),
        );
    }

    GetLocationSnapshotReportsAsync(locationSnapshotFilters: LocationSnapshotFilters):Observable<any> {
        return this.http.post<any>(environment.apiBaseUrl + `locationsnapshot/locationsnapshotreports`, locationSnapshotFilters).pipe(
            catchError(err => this.handleError(err)),
        );
    }

    private handleError(error): Observable<Response> {
        if (error && error.error && error.error.message) {
            this.notificationService.alert("error", "Client-side error: ", error);
        }else if(error && error.message) {
            this.notificationService.alert("error", "Server-side error: ", error);
        }else {
            this.notificationService.alert("error", "Error: ", JSON.stringify(error));
        }

        return error;
    }

}
